import { FC } from "react";
import { Flex, Text } from "@smile2impress/components/relaunch";

import { useGetContent } from "../../utils/useGetContent";
import { FlagshipBadgeProps } from "./FlagshipBadge.types";

export const FlagshipBadge: FC<FlagshipBadgeProps> = (props) => {
    const { flagshipLabel } = useGetContent();

    return (
        <Flex
            {...props}
            justifyContent="center"
            alignItems="center"
            p={0.5}
            borderRadius={4}
            cursor="default"
        >
            <Text
                textStyle="captionSmall"
                color="inherit"
                _dark={{ color: "text.baseInverse" }}
            >
                {flagshipLabel}
            </Text>
        </Flex>
    );
};
